import { uzivateliaController } from "../controllers/uzivatelia.controller";
import { BehaviorSubject } from "rxjs";
import { authHeader } from "../components/common/AuthHeader";
import cookie from "react-cookies";
import { logController } from "../controllers/log.controller";
import { LogLevel } from "../enums";

const currentUserSubject = new BehaviorSubject(JSON.parse(localStorage.getItem("currentUser")));

export const authenticationService = {
    login,
    logout,
    clearAuthentication,
    currentUser: currentUserSubject.asObservable(),
    get currentUserValue() {
        return currentUserSubject.value;
    },
    get currentUzivatel() {
        return cookie.load("uzivatel");
    },
    get currentUzivatelMeno() {
        return cookie.load("uzivatelMeno");
    },
    get currentSklad() {
        return cookie.load("sklad");
    },
    get currentSkladNazov() {
        return cookie.load("skladNazov");
    },
    get requestOptions() {
        return { method: "GET", headers: authHeader() };
    },
    hasCurrentUserRole(roleName) {
        return currentUserSubject.value && currentUserSubject.value.roles && currentUserSubject.value.roles.includes(roleName);
    }
};

/**
 * Přihlášení uživatele a ověření loginu a hesla pro vybranou prodejnu / sklad.
 *
 * @param {*} username
 * @param {*} password
 * @param {*} sklad
 * @returns
 */
function login(username, password, sklad) {
    return uzivateliaController.authenticate(username, password, sklad).then(
        (user) => {
            // store user details and jwt token in local storage to keep user logged in between page refreshes
            localStorage.setItem("currentUser", JSON.stringify(user));

            //const maxAge = 60 * 30;
            const skladMaxAge = 60 * 60 * 24 * 365;
            const skladExpires = new Date();
            skladExpires.setDate(Date.now() + 1000 * skladMaxAge);

            cookie.save("uzivatel", user.uzivatel, { path: "/" });
            cookie.save("uzivatelMeno", user.meno, { path: "/" });
            cookie.save("sklad", user.sklad, { path: "/", expires: skladExpires, maxAge: skladMaxAge });
            cookie.save("skladNazov", user.skladNazov, { path: "/", expires: skladExpires, maxAge: skladMaxAge });

            currentUserSubject.next(user);

            return user;
        },
        (error) => {
            logout();
            logController.logMessage(error, LogLevel.Error);
            return { errorMessage: error };
        }
    );
}

/**
 * Vymazání autentizačních údajů z cookies a local storage.
 *
 */
function clearAuthentication() {
    // remove user from local storage to log user out
    localStorage.removeItem("currentUser");
    cookie.remove("uzivatel", { path: "/" });
    cookie.remove("uzivatelMeno", { path: "/" });
}

/**
 * Odhlášení uživatele.
 *
 */
function logout() {
    clearAuthentication();
    currentUserSubject.next(null);
}



// WEBPACK FOOTER //
// ./src/services/authentication.service.js